import '../styles/pages/MentionsLegales.scss';
import { useTranslation } from 'react-i18next';

const MentionsLegales = () => {
    const { t } = useTranslation();
    return (
        <div className="main-container">
            <div className='mentions-header'>
                <h1>{t('legal.header.title')} <span className='colored'>{t('legal.header.colored')}</span></h1>
            </div>
            <div className='mentions-content'>
                <div className='mentions-section'>
                    <h2>{t('legal.owner.title')}</h2>
                    <div className='mentions-info'>
                        <p><strong>{t('legal.owner.company')}</strong></p>
                        <p>{t('legal.owner.address')}</p>
                        <p>{t('legal.owner.phone')}</p>
                        <p>{t('legal.owner.email')} <a href="mailto:sofiene.bahi@2sfirms.com">sofiene.bahi@2sfirms.com</a></p>
                        <p>{t('legal.owner.id')}</p>
                    </div>
                </div>

                <div className='mentions-section'>
                    <h2>{t('legal.design.title')}</h2>
                    <div className='mentions-info'>
                        <p><a href="https://www.instagram.com/we_tekup/" target="_blank" rel="noopener noreferrer">WE TEKUP</a></p>
                    </div>
                </div>

                <div className='mentions-section'>
                    <h2>{t('legal.hosting.title')}</h2>
                    <div className='mentions-info'>
                        <p><a href="https://www.hostinger.com/" target="_blank" rel="noopener noreferrer">https://www.hostinger.com/</a></p>
                        <p>{t('legal.hosting.host')}</p>
                        <p>{t('legal.hosting.location')}</p>
                    </div>
                </div>

                <div className='mentions-section'>
                    <h2>{t('legal.conception.title')}</h2>
                    <div className='mentions-info'>
                        <p>{t('legal.conception.designer')} <a href="https://www.instagram.com/we_tekup/" target="_blank" rel="noopener noreferrer">WE TEKUP</a></p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MentionsLegales;
